var browserCheck = (function () {
    function browserCheck() {
    }
    if (typeof window === 'undefined') { return browserCheck; }
    Object.defineProperty(browserCheck, "isMobile", {
        get: function () {
            return window.innerWidth < 600;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isTablet", {
        get: function () {
            return window.innerWidth >= 600 && window.innerWidth < 900;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isDesktop", {
        get: function () {
            return window.innerWidth >= 900;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isIPhone", {
        get: function () {
            return /i(Phone|Pod)/i.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isIPad", {
        get: function () {
            return /iPad/i.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isIOS", {
        get: function () {
            return browserCheck.isIPad || browserCheck.isIPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isAndroid", {
        get: function () {
            return /Android/i.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isIOSNativeApp", {
        get: function () {
            return /app-ios-smartphone/i.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isAndroidNativeApp", {
        get: function () {
            return /app-android-smartphone/i.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isNativeSmartphoneApp", {
        get: function () {
            return browserCheck.isIOSNativeApp || browserCheck.isAndroidNativeApp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isIOSNativeTabletApp", {
        get: function () {
            return /app-ios-tablet/i.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isAndroidNativeTabletApp", {
        get: function () {
            return /app-android-tablet/i.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isNativeTabletApp", {
        get: function () {
            return (browserCheck.isIOSNativeTabletApp || browserCheck.isAndroidNativeTabletApp);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isNativeApp", {
        get: function () {
            return browserCheck.isNativeSmartphoneApp || browserCheck.isNativeTabletApp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isAndroidApp", {
        get: function () {
            return (browserCheck.isAndroidNativeApp || browserCheck.isAndroidNativeTabletApp);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(browserCheck, "isIOSApp", {
        get: function () {
            return browserCheck.isIOSNativeApp || browserCheck.isIOSNativeTabletApp;
        },
        enumerable: true,
        configurable: true
    });
    return browserCheck;
}());

export default browserCheck;
export { browserCheck };
//# sourceMappingURL=index.js.map
